export default __webpack_public_path__ + "static/media/DP2 2C.c4769596.jpg";